import { Component, Input, OnDestroy, OnInit, OnChanges } from "@angular/core";
import { TCIApplicationMonitoringMode, ITCIMetricsStatus } from "@tci/common";
import * as lodash from "lodash";

interface ITCICPUMemStats {
    max: number;
    min: number;
}

/**
 * This is a re-usable component to show CPU /Memory stats in different areas for a given app
 */
@Component({
    selector: "ng-app-cpu-memory-stats",
    templateUrl: "./ng-app-cpu-memory-stats.component.html",
    styleUrls: ["./ng-app-cpu-memory-stats.component.less"]
})
export class NgAppCpuMemoryStatsComponent implements OnInit, OnChanges, OnDestroy {
    @Input() mode: TCIApplicationMonitoringMode;
    @Input() cpuData: ITCIMetricsStatus[];
    @Input() memoryData: ITCIMetricsStatus[];
    @Input() showMemory = true;
    @Input() showCPU = true;

    cpuFormat: ITCICPUMemStats;
    pieChartCpu = {
        view: [160, 100],
        // view: undefined,
        colorScheme: { domain: ["#75edbf", "#E44D25"] },
        data: [] as { name: string, value: number }[],
        min: 0,
        max: 100,
        pieAngleSpan: 180,
        pieStartAngle: -90,
        showAxis: false,
        toolTipDisabled: true,
        label: "",
        animate: false
    };

    memoryFormat: ITCICPUMemStats;
    pieChartMemory = lodash.assign(lodash.cloneDeep(this.pieChartCpu), { colorScheme: { domain: ["#b41c62", "#E44D25"] } });

    constructor() {
        this.resetCPU();
        this.resetMemory();
    }

    ngOnInit(): void { }

    ngOnChanges() {
        this.formatInputData();
    }

    ngOnDestroy(): void { }

    private resetCPU() {
        this.setCPU(0, 0, 0);
    }

    private resetMemory() {
        this.setMemory(0, 0, 0);
    }

    private setCPU(value: number, max: number, min: number) {
        this.pieChartCpu.data = [{ name: "CPU", value }];
        this.pieChartCpu.label = value + "%";
        this.cpuFormat = { max, min };
    }

    private setMemory(value: number, max: number, min: number) {
        this.pieChartMemory.data = [{ name: "Memory", value }];
        this.pieChartMemory.label = value + "%";
        this.memoryFormat = { max, min };
    }

    private formatInputData() {
        if (this.cpuData && this.cpuData.length > 0) {
            const value = Math.round(Number(this.cpuData.find(r => r.labels.status === "avg").value));
            const max = Math.round(Number(this.cpuData.find(r => r.labels.status === "max").value));
            const min = Math.round(Number(this.cpuData.find(r => r.labels.status === "min").value));
            this.setCPU(value, max, min);
        } else {
            this.resetCPU();
        }

        if (this.memoryData && this.memoryData.length > 0) {
            const value = Math.round(Number(this.memoryData.find(r => r.labels.status === "avg").value));
            const max = Math.round(Number(this.memoryData.find(r => r.labels.status === "max").value));
            const min = Math.round(Number(this.memoryData.find(r => r.labels.status === "min").value));
            this.setMemory(value, max, min);
        } else {
            this.resetMemory();
        }
    }
}
